module.exports = __webpack_public_path__ + "static/media/rss.f62800fc.txt";